<div class="row">
  <div class="columns">
    <h4 class="mos-u-display--inline-block mos-u-spacer--margin-top-sm">Data Tables - Default Settings</h4>
    <div class="row" *ngFor="let preference of preferences$ | async">
      <div class="column small-12 medium-3 user-data-table-label-column user-detail-label">
        <label class=" dsp-label user-detail-label"
          *ngIf="(country === 'nz') || (country === 'au' && preference !== 'taxDetails')">{{ prefLabels[ preference ]
          }}:</label>
      </div>
      <div class="column small-12 medium-6" style="display: flex; align-items: center; gap: 16px;">
        <ng-template [ngIf]="(country === 'nz') || (country === 'au' && preference !== 'taxDetails')">
          <atlas-field-select [style.--radius-xsmall]="'4px'" [clearable]="false" [(ngModel)]="preferences[preference]"
            [id]="preference + 'select'" *ngIf="preference !== 'financialYearStartMonth'" [options]="getNumberOptions()"
            [size]="sizeSmall" [widthValue]="200">
          </atlas-field-select>

          <atlas-field-select [style.--radius-xsmall]="'4px'" [clearable]="false" [(ngModel)]="preferences[preference]"
            [id]="preference + 'select'" *ngIf="preference === 'financialYearStartMonth'" [options]="FINANCIAL_MONTH"
            [size]="sizeSmall" [widthValue]="200">
          </atlas-field-select>
        </ng-template>
        <span *ngIf="(preference !== 'financialYearStartMonth') && ((country==='nz') || (country==='au' && preference
              !=='taxDetails' ) )" class="user-data-table-decimal-span">decimal places</span>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="columns table-data-footer__align-right shrink">
    <atlas-button id="button-tables-data-save" [style]="'strong'" [color]="'brand'" (click)="onSubmit()">Save
    </atlas-button>
    <atlas-button id="button-tables-data-cancel" variant="text" [style]="'no-fill'" variant="text" (click)="onCancel()">
      Cancel
    </atlas-button>
  </div>
</div>